exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\ninput[type=\"radio\"][data-v-2f7f0c45], span[data-v-2f7f0c45] {\n  display: inline-block;\n  width: auto;\n  vertical-align: middle;\n  margin-top: 0;\n}\nlabel[data-v-2f7f0c45] {\n  margin-right: 20px;\n}\n", "", {"version":3,"sources":["C:/Work/web-backoffice/src/components/Settings/controls/RadioBoolean.vue"],"names":[],"mappings":";AACA;EACE,sBAAsB;EACtB,YAAY;EACZ,uBAAuB;EACvB,cAAc;CACf;AACD;EACE,mBAAmB;CACpB","file":"RadioBoolean.vue","sourcesContent":["\ninput[type=\"radio\"][data-v-2f7f0c45], span[data-v-2f7f0c45] {\n  display: inline-block;\n  width: auto;\n  vertical-align: middle;\n  margin-top: 0;\n}\nlabel[data-v-2f7f0c45] {\n  margin-right: 20px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2f7f0c45","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Settings/controls/RadioBoolean.vue
// module id = 1988
// module chunks = 0